import {
  Component,
  EventEmitter,
  Output
}	from '@angular/core';

@Component({
  selector:			'electra-slide-bar',
  styleUrls:		[ './slideBar.component.scss' ],
  templateUrl:	'./slideBar.component.html'
})
export class SlideBarComponent {
	@Output() close		= new EventEmitter<any>();
	@Output() update	= new EventEmitter<number>();

  currentY: any = null;
  startY:   any = null;

  startDrag(event: any) {
    this.currentY = null;
    this.startY = event.touches[0].clientY;
  }

  stopDrag() {
    if (typeof this.currentY === 'number') {
      if (this.currentY - this.startY > 100) {
        this.close.emit();
      } else {
				this.update.emit(0);
			}
    } else {
      this.close.emit();
    }
  }

  updateDrag(event: any) {
    this.currentY = event.touches[0].clientY;

		this.update.emit(this.startY - this.currentY);
  }
}



// WEBPACK FOOTER //
// ./src/app/electraLib/component/slideBar/slideBar.component.ts